import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { FlexRow } from '../../atoms/layout/Flex'
import Label from '../../atoms/display/Label'
import { CompanyConstruction } from '../../../types/Company'
import { JobSelectors } from '../../../store/job/selectors'
import { ConstructionType } from '../../../types/job'

type Props = {
  constructions: CompanyConstruction[]
  highlightConstructionTypeIds: string[]
}

export default function CompanyConstructionsView({ constructions, highlightConstructionTypeIds }: Props) {
  const constructionTypes = useSelector(JobSelectors.constructionTypes)
  const constructionMap: { [key: string]: ConstructionType } = {}
  constructionTypes.forEach((type) => {
    constructionMap[type.id] = type
  })
  if (constructions.length === 0) {
    return (
      <Box px={0.5}>
        <Label text="未設定" />
      </Box>
    )
  }
  return (
    <FlexRow wrap>
      {constructions.map((construction) => (
        <Box
          key={construction.typeId}
          bgcolor={highlightConstructionTypeIds.includes(construction.typeId) ? '#fdd835' : undefined}
          px={0.5}
        >
          <Label text={constructionMap[construction.typeId].name} />
        </Box>
      ))}
    </FlexRow>
  )
}
